/* eslint-disable one-var */
import _ from 'lodash'

export default {
    install(Vue) {
        // 1. add global method or property
        Vue.prototype.$generate_noty = (notyType, text, duration, group) => {
            let opt = {
                group: group || 'foo', // default group
                duration: duration || 5000, // duration of the notify
                text: text
            }
            if (notyType === 'error') {
                opt['type'] = 'error'
                opt['title'] = 'Error!'
            } else if (notyType === 'success') {
                opt['type'] = 'success'
                opt['title'] = 'Satisfactorio!'
            } else if (notyType === 'warn') {
                opt['type'] = 'warn'
                opt['title'] = 'Atención!'
            } else {
                opt['title'] = 'Información!'
            }
            Vue.prototype.$notify(opt);
        }

        Vue.prototype.$generate_toast = (vm, notyType, text, title, duration, toaster) => {
            let opt = {
                toaster: toaster || 'b-toaster-top-right', // default toaster
                autoHideDelay: duration || 5000, // duration of the notify
                solid: true,
            }
            if (notyType === 'error') {
                opt['variant'] = 'danger'
                opt['title'] = title || '¡Error!'
            } else if (notyType === 'success') {
                opt['variant'] = 'success'
                opt['title'] = title || '¡Satisfactorio!'
            } else if (notyType === 'warn') {
                opt['variant'] = 'warning'
                opt['title'] = title || '¡Atención!'
            } else {
                opt['variant'] = 'info'
                opt['title'] = title || '¡Información!'
            }
            vm.$bvToast.toast(text, opt)
        }
        Vue.prototype.$axios_error_noty = (e, vm) => {
            // Receives an axios catched error
            if (e.response) {
                if (e.response.status === 403 && 'data' in e.response) {
                    if (vm) {
                        Vue.prototype.$generate_toast(vm, 'error', e.response.data.detail);
                    } else {
                        Vue.prototype.$generate_noty('error', e.response.data.detail);
                    }
                } else if (e.response.status === 404 && 'data' in e.response) {
                    if (vm) {
                        Vue.prototype.$generate_toast(vm, 'error', `Error 404, ${e.response.data.detail}`);
                    } else {
                        Vue.prototype.$generate_noty('error', `Error 404, ${e.response.data.detail}`);
                    }
                } else if (e.response.status === 400 && 'data' in e.response) {
                    Object.keys(e.response.data).forEach(key => {
                        if (vm) {
                            Vue.prototype.$generate_toast(vm, 'error', e.response.data[key], key);
                        } else {
                            Vue.prototype.$generate_noty('error', `<b>${key}</b><br/>${e.response.data[key]}`);
                        }
                    });
                } else if (e.response.status === 401) {
                    if (vm) {
                        vm.$router.push({ name: 'logout', params: { expiredSession: true } })
                    } else {
                        Vue.prototype.$generate_noty(
                            'error', 'Your session has expired, please log in again'
                        );
                    }
                } else if (e.response.status === 500) {
                    if (vm) {
                        Vue.prototype.$generate_toast(vm, 'error', 'Internal server error');
                    } else {
                        Vue.prototype.$generate_noty('error', 'Internal server error');
                    }
                }
            } else {
                if (vm) {
                    Vue.prototype.$generate_toast(vm, 'error', e.message);
                } else {
                    Vue.prototype.$generate_noty('error', e.message);
                }
            }
        }

        Vue.prototype.$table_params = (ctx) => {
            /* Receive a vue datatable filters:
                {
                    apiUrl: ""
                    currentPage: 1
                    filter: null
                    perPage: 0
                    sortBy: ""
                    sortDesc: false
                }
            */
            let query = ''
            if (ctx.filterset) {
                query = query ? query + `&${ctx.filterset}` : `${ctx.filterset}`
            }
            if (ctx.filter) {
                query = query ? query + `&search=${ctx.filter}` : query + `search=${ctx.filter}`
            }
            if (ctx.perPage) {
                query = query ? query + `&page_size=${ctx.perPage}` : query + `page_size=${ctx.perPage}`
            }
            if (ctx.currentPage) {
                query = query ? query + `&page=${ctx.currentPage}` : query + `page=${ctx.currentPage}`
            }
            if (ctx.sortBy) {
                if (ctx.sortDesc) {
                    query = query ? query + `&ordering=${ctx.sortBy}` : query + `ordering=${ctx.sortBy}`
                } else {
                    query = query ? query + `&ordering=-${ctx.sortBy}` : query + `ordering=-${ctx.sortBy}`
                }
            }
            return query ? `?${query}` : query
        }

        Vue.prototype.$select_params = (searchQuery) => {
            /* Receive a vue multiselect query filter: */
            let query = '?page_size=200'
            return searchQuery ? `${query}&search=${searchQuery}` : query
        }

        Vue.prototype.$syllabify = (word) => {
            // Test it: console.log(['away', 'hair', 'halter', 'hairspray', 'father', 'lady', 'kid'].map(syllabify))
            // Return an array with each sillable
            const syllableRegex = /[^aeiouy]*[aeiouy]+(?:[^aeiouy]*$|[^aeiouy](?=[^aeiouy]))?/gi;
            return word.match(syllableRegex);
        }

        Vue.prototype.$truncateWords = (word, n) => {
            return word.substr(0, n - 1) + (word.length > n ? '...' : '');
        }

        Vue.prototype.$arraySuffle = (array) => {
            var currentIndex = array.length,
                temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex !== 0) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        }

        Vue.prototype.$toUpperCase = (value) => {
            return _.upperCase(value)
        }
    }
}